import Model from './Model';

export default class AffiliatePaymentHistory extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'affiliate-payment-histories';
  }
}
